import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // 1. Import hook i18n

export default function AccountActivatedPage() {
    const { t } = useTranslation('registration'); // 2. Gunakan namespace registration
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-green-100 px-4">
            <div className="bg-white shadow-lg rounded-2xl p-8 max-w-lg w-full text-center border border-gray-100">
                <div className="flex justify-center mb-6">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                        className="flex flex-col items-center mb-3"
                    >
                        <img
                            src="/konaspi.png"
                            alt="Logo Konaspi XII"
                            className="w-24 h-auto mb-3"
                        />
                        {/* Garis pemisah di bawah logo */}
                        <div className="w-70 h-[2px] bg-gradient-to-r from-indigo-400 via-purple-500 to-blue-500 rounded-full"></div>
                    </motion.div>
                </div>

                <h1 className="text-3xl font-bold text-green-700 mb-3">
                    {t('activation_success.title')}
                </h1>

                <p className="text-gray-700 leading-relaxed mb-6 text-justify">
                    {t('activation_success.description_part1')}{" "}
                    <b>{t('activation_success.description_highlight')}</b> {t('activation_success.description_part2')}{" "}
                    <b>{t('activation_success.description_highlight2')}</b> {t('activation_success.description_part3')}
                    <br />
                    <br />
                    {t('activation_success.instruction')}
                </p>

                <Button
                    onClick={() => navigate("/login")}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2"
                >
                    {t('activation_success.btn_login')}
                </Button>

                <div className="mt-8 border-t border-gray-200 pt-4 text-sm text-gray-500">
                    <p>© {new Date().getFullYear()} Konaspi XII - Universitas Pendidikan Ganesha</p>
                </div>
            </div>
        </div>
    );
}